import ContactUsContent from "$lib/data/generated/content/contact us/data.json";

import { uploads as ContactUsUploads } from "$lib/data/generated/uploads/contact us/uploads";

const content = {
	["contact us"]: ContactUsContent
};
const uploads = {
	...ContactUsUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
